import * as React from "react";
import * as classNames from "classnames";
import { NationalId } from "./NationalId";
import i18next from "i18next";
export var IdentityCard = function (_a) {
    var user = _a.user, className = _a.className;
    return (React.createElement("div", { className: classNames("bg-secondary p-2", className) },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md my-1" },
                React.createElement("strong", null,
                    " ",
                    i18next.t("cc.add.issue.name")),
                React.createElement("br", null),
                user.firstName,
                " ",
                user.lastName),
            React.createElement("div", { className: "col-md my-1" }, user.nationalId ? (React.createElement(React.Fragment, null,
                React.createElement("strong", null,
                    " ",
                    i18next.t("cc.add.issue.socialSecurityNumber")),
                React.createElement("br", null),
                React.createElement(NationalId, { nationalId: user.nationalId, country: user.organization.country }))) : user.tfNumber ? (React.createElement(React.Fragment, null,
                React.createElement("strong", null,
                    " ",
                    i18next.t("cc.add.issue.temporarySocialSecurityNumber")),
                React.createElement("br", null),
                user.tfNumber)) : null))));
};
//# sourceMappingURL=IdentityCard.js.map